// Company list mappers: transport layer ↔ domain models

import type {
  LC_CompanyRecordOut,
  LC_CompanyRecordOutPagedResult,
  Company,
  CompaniesPage,
} from '../types/companyList.types';

/**
 * Maps transport company record to internal Company model
 */
export function mapCompanyRecordToModel(
  transport: LC_CompanyRecordOut,
): Company {
  return {
    id: transport.companyId,
    name: transport.companyName || '',
    rut: transport.companyRUT || '',
    type: transport.companyType || '',
    syncWithRex: transport.syncWithRex === 'Si',
  };
}

/**
 * Maps paged transport result to internal CompaniesPage
 */
export function mapCompanyPagedResultToModel(
  transport: LC_CompanyRecordOutPagedResult,
): CompaniesPage {
  return {
    data: (transport.data || []).map(mapCompanyRecordToModel),
    totalRecords: transport.pagination.totalRecords,
    currentPage: transport.pagination.currentPage,
    pageSize: transport.pagination.pageSize,
    totalPages: transport.pagination.totalPages,
    hasPreviousPage: transport.pagination.hasPreviousPage,
    hasNextPage: transport.pagination.hasNextPage,
  };
}
